import type { UserNotificationSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export enum NotificationStatus {
  Seen = 'seen',
  Read = 'read',
  Dismissed = 'dismissed',
}

export const NotificationTitle = {
  QuoteReferred: 'Quote Referred',
  RenewalReferred: 'Renewal Referred',
  RenewalCancelled: ['Renewal Canceled', 'Renewal Cancelled'],
  RenewalDeclined: 'Renewal Declined',
  NewRenewal: 'New Renewal',
  SubmissionDeclined: 'Submission Declined',
  SubmissionRejected: 'Submission Rejected',
  SubmissionCancelled: ['Submission Canceled', 'Submission Cancelled'],
  SubmissionLapsed: 'Submission Lapsed',
  PolicyBound: 'Policy Bound',
};

export type UserNotification = ArrayItem<UserNotificationSearchResponse['items']>;
